import React, { useEffect, useCallback, useState} from 'react';
import MidiEffectComponent from 'components/effects/MidiEffectComponent.js';
import EffectComponent from 'components/effects/EffectComponent.js';
import {useEffects} from './useEffects.js';
import TrackEffects from "components/mix/mix2/TrackEffects.js";
import TriggerMeter from 'components/v2/TriggerMeter.js';
import GroupTracker from './GroupTracker.js';
import Tracker from './Tracker.js';
import {moveTrackToGroup} from './moveTrackToGroup.js';
import TrackControls from './TrackControls.js';
import Colors from 'components/Colors.js';
import VolumeSlider from './VolumeSlider.js';
import MultiFreezeThumbnails from 'components/freeze/MultiFreezeThumbnails.js';
import {connect} from 'react-redux';
import {
    setSelectedGroup,
    setMixTrackDragging,
} from 'actions/index.js';
import {MULTI_FREEZE} from 'constants/track-types.js';
import {MULTI_SYNTH} from 'constants/instrument-types.js';
import {getTrackShortName} from 'utils/getTrackShortName.js';

const colors = new Colors();

const Track = ({
    track,
    group,
    volume,
    muted,
    isAlone,
    isSelected,
    setSelectedGroup,
    setMixTrackDragging,
    trackDragging,
    selectedEffect,
    selectedMidiEffect
}) => { 
    let thumbnail = track.sample && track.sample.getThumbnail();
    let color = colors.getColorForTrack(track);
    let style = {
        backgroundColor: color
    };

    if (thumbnail) {
        style.backgroundImage = 'url(' + thumbnail + ')';
    }

    const {onDeleteEffect, effects} = useEffects({trackOrGroup: track});

    let className = isAlone ? "group-track alone" : "group-track";

    let trackStyle = {};

    if (isSelected) {
        className += " selected";
        trackStyle.boxShadow = "0px 0px 2px 2px " + color;
    }

    let thumbnailClass = "track-thumbnail";
    if (muted) {
        thumbnailClass += " muted";
    }

    const toggleMute = useCallback(() => {
        track.mute(!muted);
    }, [muted, track]);

    const selectTrack = useCallback((e) => {
        e.stopPropagation();
        setSelectedGroup(undefined);
        track.sequencerEngine.selectTrack(track.trackNumber);
    }, [track]);

    const onDrop = useCallback((e) => {
        e.stopPropagation();
        if (track !== trackDragging) {
            moveTrackToGroup(trackDragging, track.group);
        }
    }, [track, trackDragging]);

    let innerText = getTrackShortName(track);
    if (selectedEffect || selectedMidiEffect) {
        className += " showing-effects";
    }
    return (
        <div
          onDrop={onDrop}
          draggable={true}
          onDragStart={() => setMixTrackDragging(track)}
          style={trackStyle}
          onDragOver={(e) => e.preventDefault()}
          onMouseDown={selectTrack}
          className={className}>
          <div
            style={isSelected ? {backgroundColor: color} : {}}
            className="track-info">
            {track.trackNumber + 1} {truncateName(track.presetName || track.getName() || "Track")}
          </div>
          {selectedEffect ?
           <EffectComponent
             sequencerEngine={track.sequencerEngine}
             onDeleteEffect={onDeleteEffect}
             track={track}
             compact={true}
             effect={selectedEffect}
             send={undefined}/>  : 
           selectedMidiEffect ?
           <MidiEffectComponent
             sequencerEngine={track.sequencerEngine}
             effect={selectedMidiEffect}
             track={track}
             compact={true}
           /> :
           <div>
             <VolumeSlider track={track} volume={volume} setVolume={(v) => track.setVolume(v)}/>
             <div
               onClick={toggleMute}
               style={style} className={thumbnailClass}>
               {thumbnail === undefined ? innerText : ""}
             </div>
             <TriggerMeter color={color} track={track}/>
             <TrackControls isSelected={isSelected} track={track}/>
           </div>
          }
          <TrackEffects effects={effects} track={track}/>
        </div>
    );
          /*{isAlone ? <GroupTracker group={group}/> : ''}*/
}

const truncateName = name => {
    if (name === undefined) {
        return '';
    }

    if (name.length > 30) {
        name = name.slice(0, 30) + '...';
    }
    return name;
};

const mapStateToProps = (state, props) => {
    let track = props.track;
    if (track && track.tracks && track.tracks[0]) {
        track = track.tracks[0].track;
    }
    
    let subId = track && track.subSequence.id;
    return {
        id: track === undefined ? 0 :
            track.sample !== undefined && track.sample.getId() !== undefined ?
            track.sample.getId() : track.presetName || track.getName(),
        volume: props.track.volumeParameter.get(),
        muted: state.tracks.trackMutes[props.track.trackNumber],
        isSelected: state.mix.selectedTrack === props.track.trackNumber &&
            state.mix.selectedGroup === undefined,
        trackDragging: state.mix.trackDragging,
        selectedEffect: track !== undefined && state.mix.selectedTrackEffects[subId] &&
            state.mix.selectedTrackEffects[subId][track.id],
        selectedMidiEffect: track !== undefined && state.mix.selectedTrackMidiEffects[subId] &&
            state.mix.selectedTrackMidiEffects[subId][track.id]
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedGroup: (g) => dispatch(setSelectedGroup(g)),
      setMixTrackDragging: (t) => dispatch(setMixTrackDragging(t))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Track);
